import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { getNoticeCount, getNotices } from "../../services/ api_services";
import useToast from "../../hooks/useToast";
import { isEmpty } from "lodash";
import { Listbox, Transition } from "@headlessui/react";
import { ChevronUpDownIcon, CheckIcon, DocumentPlusIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination";
import axios from "axios";
import SelectMenu from "../../components/SelectMenu";

const Notice = () => {
    const navigate = useNavigate();

    const searchType = [
        { name: "제목", value: "title" },
        { name: "작성자", value: "admin" },
    ];

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    const pageSizes = [20, 50, 100];

    const initialCond = {
        search_word: "",
        search_type: "",
    };

    const [list, setList] = useState([]);
    const [selected, setSelected] = useState(searchType[0]);
    const [cond, setCond] = useState(initialCond);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[0]);

    const onSearch = async () => {
        const data = {
            page_number: currentPage,
            page_size: pageSize,
            search_word: cond.search_word,
            search_type: selected.value,
        };
        await fetchNotices(data);
        await fetchNoticeCount(data);
    };

    // useEffect(() => {
    //     onSearch();
    // }, []);

    useEffect(() => {
        // console.log("currentPage", currentPage);
        onSearch();
    }, [currentPage, pageSize]);

    const listclick = async (seq) => {
        navigate("/ad/addNotice/?id=" + seq);
    };

    /**
     *  총 리스트 카운트 가져오기
     */
    const fetchNoticeCount = async (data) => {
        try {
            console.log("🚀 ~ fetchNoticeCount ~ data:", data);
            const response = await getNoticeCount(data);
            console.log("🚀 ~ fetchNoticeCount ~ response:", response);

            if (response && response.status === 200) {
                setTotalCount(response.data);
            } else {
                setTotalCount(0);
            }
        } catch (e) {
            if (axios.isCancel(e)) {
                //console.log("요청이 취소되었습니다:", e.message);
            } else {
                console.error("Error fetching data: ", e);
            }
        }
    };

    const fetchNotices = async (data) => {
        const responseList = await getNotices(data);
        console.log("🚀 ~ fetchNotices ~ responseList:", responseList);
        if (responseList && responseList.status === 200 && !isEmpty(responseList.data)) {
            console.log("🚀 ~ fetchNotices ~ responseList.data:", responseList.data);
            responseList.data.map((item) => {
                item.notice.reg_dt = formatDate(item.notice.reg_dt);
                return item;
            });
            console.log("🚀 ~ responseList.data.map ~ responseList.data:", responseList.data);
            setList(responseList.data);
        } else {
            setList([]);
        }
    };

    function formatDate(dateString) {
        // console.log("🚀 ~ formatDate ~ dateString:", dateString);
        if (!dateString) return;
        // 날짜 뒤에 지워줌
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        };
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(/(\d{2})\/(\d{2})\/(\d{4}),/, "$3-$1-$2");
    }
    /**
     * 엔터키 이벤트
     * @returns
     */
    const handleOnKeyPress = (e) => {
        console.log("🚀 ~ handleOnKeyPress ~ e.key:", e.key);
        if (e.key === "Enter") {
            onSearch(); // Enter 입력이 되면 클릭 이벤트 실행
        }
    };

    const handleOnSelectPageSize = (pageSize) => {
        console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", pageSize);
        // console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", Number(pageSize));
        setPageSize(Number(pageSize));
    };

    return (
        <div>
            <span className="flex text-center justify-center align-middle text-nowrap text-gray-800 font-semibold text-2xl">공지 사항</span>
            <div className=" bg-gray-900 max-w-full mt-6 h-max ">
                <div className="mx-auto max-w-full">
                    <div className="bg-gray-900 py-10">
                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none flex justify-end">
                                {/* 등록 버튼 */}
                                <button
                                    type="button"
                                    className="inline-flex items-center gap-x-1.5 rounded-md bg-blue-700 px-4 py-2 text-center text-sm font-semibold text-white hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                                    onClick={() => {
                                        navigate("/ad/addNotice");
                                    }}
                                >
                                    <DocumentPlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                                    공지등록
                                </button>
                                {/* <button type="button"
        onClick={() => onSearch()}
        className="mx-2 w-32 rounded-md inline-flex gap-x-1 items-center justify-center bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500" >
        <SlReload className="-ml-0.5 h-5 w-5" aria-hidden="true" />
        조회
      </button> */}
                            </div>
                            <div className="mt-5 flex justify-between">
                                <div className="flex w-5/12 space-x-3 sm:space-x-2">
                                    <div className="min-w-32">
                                        <SelectMenu options={searchType} onSelect={setSelected} selectedId={selected.value} />
                                    </div>
                                    <input
                                        type="search"
                                        className="block w-8/12 rounded border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                        onChange={(e) => {
                                            setCond((prevState) => {
                                                return { ...prevState, search_word: e.target.value.trim() };
                                            });
                                        }}
                                        onKeyDown={handleOnKeyPress}
                                    />
                                    <button
                                        type="button"
                                        className="whitespace-nowrap rounded bg-white py-2 px-5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 "
                                        onClick={() => {
                                            onSearch();
                                        }}
                                    >
                                        검색
                                    </button>
                                </div>
                                <div className="flex items-center justify-between align-middle">
                                    <label className="w-40 text-start text-base font-medium text-white">조회 개수 </label>
                                    <select
                                        className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        defaultValue={pageSizes && pageSizes[0]}
                                        onChange={(e) => handleOnSelectPageSize(e.target.value)}
                                    >
                                        {pageSizes.map((item) => {
                                            return <option>{item}</option>;
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="mt-8 flow-root">
                                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                        <table className="min-w-full divide-y divide-gray-700">
                                            <thead>
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        className="py-3.5 px-1 text-left text-sm font-semibold text-white sm:pl-0"
                                                    >
                                                        NO
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                                                        제목
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                                                        작성자
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                                                        등록일
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                                                        사용여부
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-white">
                                                        조회수
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-800">
                                                {list &&
                                                    list.map((item, index) => {
                                                        {
                                                            return (
                                                                <tr
                                                                    key={index}
                                                                    onClick={() => {
                                                                        listclick(item.notice.seq);
                                                                    }}
                                                                    className="hover:bg-slate-800"
                                                                >
                                                                    <td className="whitespace-nowrap py-2 text-left text-sm font-medium text-white sm:pl-0">
                                                                        {index + 1}
                                                                    </td>
                                                                    <td
                                                                        className="whitespace-nowrap max-w-80 overflow-hidden px-3 text-left text-sm text-gray-300"
                                                                        //style={{ maxlength:5, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"} } 글자수 제한
                                                                    >
                                                                        {item.notice.title}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 text-left text-sm text-gray-300">
                                                                        {item.admin_nm}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 text-left text-sm text-gray-300">
                                                                        {item.notice.reg_dt}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 text-left  text-sm text-gray-300">
                                                                        {item.notice.useYn === "Y" ? "사용" : "미사용"}
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 text-left text-sm text-gray-300">
                                                                        {item.notice.views}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        }
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                totalCount={totalCount}
                itemsPerPage={pageSize}
                // onPageChange={handleOnPageChange}
            />

            {/* !!!!!!!!!! */}
            {/* <div className="w-full max-w-full rounded-1xl bg-gray-100 border-gray-300 border px-4 py-4 justify-start items-center"> */}

            <div className="flex justify-end pb-5">
                {" "}
                {/*버튼 있던 자리*/}
                {/* <button
        type="button"
        className="block rounded-md bg-blue-700 px-3 py-2 text-center text-sm font-semibold text-white hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
        onClick={() => {
          window.location.href = "/ad/addNotice";
        }}
      >
        공지등록
      </button>
      <button type="button"
        onClick={() => onSearch()}
        className="mx-2 w-32 rounded-md inline-flex gap-x-1 items-center justify-center bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500" >
        <SlReload className="-ml-0.5 h-5 w-5" aria-hidden="true" />
        조회
      </button> */}
            </div>

            {/* <div className="px-2 py-2 justify-start items-center" class="bg-gray-900 py-10" style={{ border: "1px" }} >
      
      <div class="px-4 sm:px-6 lg:px-8">
        
      
        <table className="min-w-full divide-y divide-gray-700">
          <thead>
            <tr>
              <th
                scope="col"
                className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-white sm:pl-0"
              >
                NO
              </th>
              <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                제목
              </th>
              <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                등록자
              </th>
              <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                등록일
              </th>
              <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                수정일
              </th>
              <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                조회수
              </th>

            </tr>
          </thead>
          <tbody className="divide-y divide-gray-800">
            리스트 있던 자리
              
          </tbody>
        </table>
        
      </div>
      
      </div>
       */}
            {/*<div><textarea className="rounded-md" type="text" value={(Submit.title)}></textarea></div>
        <div><textarea className="rounded-md" type="text" value={(Submit.content)} style={{ height: "600px" }}></textarea></div>*/}
        </div>
    );
};

export default Notice;
